var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.appWrapperStyle),attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),(_vm.devBadge)?_c('div',{staticClass:"dev-badge"},[_vm._v(_vm._s(_vm.devBadge))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }